import React from "react";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "./protected.route";

import "./App.css";
import Dashboard from "./Screens/Dashboard/dashboard.component";
import Registration from "./Screens/Registration/registration.component";
import Login from "./Screens/Login/login.component";
import PageNotFound from "./Screens/Error404/pageNotFound.component";
import ContactUs from "./Screens/Contact Us/contactUs.screen";
import ExamScreen from "./Screens/Exam Portal/exam.screen";

const App = () => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <Login {...props} title="Login" />}
        />
        <Route
          exact
          path="/Registration"
          render={(props) => <Registration {...props} title="Sign-Up" />}
        />
        <Route
          exact
          path="/Contact-Us"
          render={(props) => <ContactUs {...props} title="Contact Us" />}
        />
        <Route
          path="/Dashboard/Exam"
          render={(props) => <ExamScreen {...props} title="Exam Portal" />}
        />
        <PrivateRoute
          path="/Dashboard"
          component={Dashboard}
          title="DASHBOARD"
        />
        <Route path="*" render={(props) => <PageNotFound {...props} />} />
      </Switch>
    </div>
  );
};

export default App;
